import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

const productCarousel = new Swiper(".product-carousel .swiper", {
  // Optional parameters
  modules: [Navigation],
  loop: true,
  slidesPerView: 2,
  slidesPerGroup: 1,
  spaceBetween: 8,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // Responsive breakpoints
  breakpoints: {
    640: {
        slidesPerView: 3,
        slidesPerGroup: 1,
    },
    1200: {
        slidesPerView: 4,
        slidesPerGroup: 1,
    }
  }
});
